<section *ngIf="showSearch" class="bg-white shadow-sm py-3" [dir]="isRtl? 'rtl': 'ltr'">
  <div class="container">
    <input
      type="search"
      class="form-control shadow-none border mx-auto border-bottom"
      placeholder="{{ 'shared.search' | translate }}"
      [(ngModel)]="searchValue"
      (ngModelChange)="onSearch()"
      (keydown.enter)="openResultsPage()"
    />

    <div class="result px-2">
      <p *ngIf="noMatch" class="text-center text-muted py-3 mb-0" translate="shared.noResult"></p>
      <article class="border-bottom pb-3" *ngIf="courses.data?.length > 0">
        <div class="search-title">
          <h6 class="mb-0" translate="course.courses"></h6>
          <p class="text-muted mt-2">
            {{ "shared.result" | translate }} {{ courses.total }}
          </p>
        </div>
        <div class="row row-cols-1 gy-1">
          <div class="col" *ngFor="let course of courses.data">
            <a
              (click)="resetSearch()"
              [routerLink]="['/course/details', course.id]"
            >
              <i class="fa-solid fa-magnifying-glass"></i>
              <span>{{ isRtl ? course.titleAr : course.title }}</span>
            </a>
          </div>
          <div class="col" *ngIf="courses.total > 4">
            <a
              class="fw-bold mt-3 badge rounded-pill bg-light text-dark border fs-6"
              (click)="resetSearch()"
              translate="shared.showAll"
              [routerLink]="showAllLink"
              [queryParams]="showAllParams('courses')"
            >
            </a>
          </div>
          <div class="col" *ngIf="courses.data?.length < 1">
            <p class="mb-0 text-muted" translate="shared.noResult"></p>
          </div>
        </div>
      </article>
      <article class="border-bottom pb-3" *ngIf="paths.data?.length > 0">
        <div class="search-title">
          <h6 class="mb-0" translate="home.paths"></h6>
          <p class="text-muted mt-2">
            {{ "shared.result" | translate }} {{ paths.total }}
          </p>
        </div>
        <div class="row row-cols-1 gy-1">
          <div class="col" *ngFor="let path of paths.data">
            <a
              (click)="resetSearch()"
              [routerLink]="['/learning-path/details', path.id]"
            >
              <i class="fa-solid fa-magnifying-glass"></i>
              <span>{{ isRtl ? path.nameAr : path.name }}</span>
            </a>
          </div>
          <div class="col" *ngIf="paths.total > 4">
            <a
              class="fw-bold mt-3 badge rounded-pill bg-light text-dark border fs-6"
              (click)="resetSearch()"
              translate="shared.showAll"
              [routerLink]="showAllLink"
              [queryParams]="showAllParams('paths')"
            >
            </a>
          </div>
          <div class="col" *ngIf="paths.data?.length < 1">
            <p class="mb-0 text-muted" translate="shared.noResult"></p>
          </div>
        </div>
      </article>
      <article class="border-bottom pb-3" *ngIf="diplomas.data?.length > 0">
        <div class="search-title">
          <h6 class="mb-0" translate="diploma.title"></h6>
          <p class="text-muted mt-2">
            {{ "shared.result" | translate }} {{ diplomas.total }}
          </p>
        </div>
        <div class="row row-cols-1 gy-1">
          <div class="col" *ngFor="let diploma of diplomas.data">
            <a
              (click)="resetSearch()"
              [routerLink]="['/learning-path/details', diploma.id]"
            >
              <i class="fa-solid fa-magnifying-glass"></i>
              <span>{{ isRtl ? diploma.nameAr : diploma.name }}</span>
            </a>
          </div>
          <div class="col" *ngIf="diplomas.total > 4">
            <a
              class="fw-bold mt-3 badge rounded-pill bg-light text-dark border fs-6"
              (click)="resetSearch()"
              translate="shared.showAll"
              [routerLink]="showAllLink"
              [queryParams]="showAllParams('diplomas')"
            >
            </a>
          </div>
          <div class="col" *ngIf="diplomas.data?.length < 1">
            <p class="mb-0 text-muted" translate="shared.noResult"></p>
          </div>
        </div>
      </article>
    </div>
  </div>
</section>
